import useToken from 'hooks/useToken';
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import Greetings from './Greeting/Greetings.js';
import LeadsActualizados from './leads-actualizados/LeadsActualizados.js';
import LeadsByCountry from './leads-by-country/LeadsByCountry.js';
import LeadsPorEtapa from './leads-by-etapa/LeadsPorEtapa.js';
import DailyLeads from './leads/DailyLeads.js';
import ErrorBoundary from 'components/common/ErrorBoundary';

const AdministradoresReporteLeads = () => {

    const { token, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();

    /**
     * Se ejecuta la primera vez
     */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();

    }, []);

    /**
     * Verifica los permisos
     */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                //


            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }



    return (
        <>
            <Row className="">

                <Col className="col-12 mb-3">
                    <Greetings />
                </Col>

                <Col className="col-12 mb-3">
                    <ErrorBoundary>

                        <LeadsPorEtapa />
                    </ErrorBoundary>

                </Col>

                <Col className="col-12 mb-3">
                    <ErrorBoundary>

                        <LeadsActualizados />
                    </ErrorBoundary>

                </Col>
            </Row>

            <Row>
                <Col className="col-12 mb-3">
                    <ErrorBoundary>

                        <DailyLeads />
                    </ErrorBoundary>

                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <ErrorBoundary>
                        <LeadsByCountry />
                    </ErrorBoundary>

                </Col>
            </Row>
        </>
    );
};

export default AdministradoresReporteLeads;
